export const defaultText = 'Hi, I am Valentin, I am a Front End Developer.'
export const secondLine = 'I love '
export const js = 'JavaScript'
export const es = 'ES2015+, ES6, ES7 ...'
export const react = 'React'
export const redux = 'Redux'
export const babel = 'Babel'
export const webpack = 'Webpack'
